export const memoryScienceText = (
  <>
    <p>
      A memória humana é dividida em diferentes sistemas, sendo a <strong>memória de curto prazo</strong> uma das mais importantes para o funcionamento diário.
    </p>

    <p>
      Ela é responsável por armazenar pequenas quantidades de informação por poucos segundos ou minutos, permitindo que você execute tarefas simples como lembrar um número, uma instrução ou um padrão visual.
    </p>

    <p>
      Estudos da psicologia cognitiva mostram que essa capacidade é <strong>limitada, mas treinável</strong>. Ou seja, quanto mais você estimula seu cérebro, melhor ele se adapta.
    </p>

    <ul>
      <li>🧠 Repetição fortalece conexões neurais</li>
      <li>🎯 Foco melhora a retenção de informações</li>
      <li>⚡ Estímulos progressivos aumentam a capacidade mental</li>
    </ul>

    <p>
      Exercícios como lembrar sequências numéricas ou padrões visuais ajudam a desenvolver atenção, velocidade de raciocínio e processamento de informações no dia a dia.
    </p>
  </>
);